export const SET_EXPENSE = "SET_EXPENSE";
export const SET_TODAY_BILL_DATA = "SET_TODAY_BILL_DATA";
export const SET_CLOSING_DATA = "SET_CLOSING_DATA";


const initialState = {
    expense: null,
    todayBillData: null,
    closingData: null
}
const ExpenseReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_EXPENSE:
            return ({ ...state, expense: action.value, timestamp: Date.now() })
        case SET_TODAY_BILL_DATA:
            return ({ ...state, todayBillData: action.value, timestamp: Date.now() })
        case SET_CLOSING_DATA:
            return ({ ...state, closingData: action.value, timestamp: Date.now() })
        default:
            return state;
    }
}
export default ExpenseReducer;